import { CommonModule } from '@angular/common';
import { Component, Input, TemplateRef } from '@angular/core';

@Component({
	selector: 'msp-tooltip',
	standalone: true,
	imports: [CommonModule],
	templateUrl: './tooltip.component.html',
	styleUrl: './tooltip.component.scss',
})
export class TooltipComponent {
	@Input() content = '';
	@Input() template: TemplateRef<any> | null = null;
	@Input() anchor = '';
	@Input() tooltipNgStyles: { [key: string]: string } | Array<{ [key: string]: string }> = {};
	@Input() orientation: {
		top?: boolean;
		bottom?: boolean;
		left?: boolean;
		right?: boolean;
		middle?: boolean;
	};

	get containerStyles() {
		let positionArea = '';
		if (this.orientation.top) positionArea += 'top ';
		if (this.orientation.bottom) positionArea += 'bottom ';
		if (this.orientation.left) positionArea += 'span-right';
		if (this.orientation.right) positionArea += 'span-left';
		if (this.orientation.middle) positionArea += 'center';
		const positionStyle: { [key: string]: string } = {
			'position-area': positionArea.trim(),
			'position-anchor': this.anchor,
		};

		return positionStyle;
	}
}
